import {
  IPerformanceTrackingOptions,
  IWebVitals,
  WEB_VITAL_ATTRIBUTE_NAME,
} from 'tracking/types/WebVital';
import { sendTrackingEvent } from 'tracking/utils/sendTrackingEvent';

const mapWebVitals = (pageWebVitals: Map<IWebVitals, number>) => {
  const attributes = new Map<WEB_VITAL_ATTRIBUTE_NAME, number>();

  for (const [key, value] of pageWebVitals) {
    attributes.set(WEB_VITAL_ATTRIBUTE_NAME[key], value);
  }

  return attributes;
};

const sendPerformanceAnalytics = (
  pageWebVitals: Map<IWebVitals, number>,
  eventName: string,
  opts?: IPerformanceTrackingOptions,
) => {
  const pageWebVitalsAttributes = mapWebVitals(pageWebVitals);
  sendTrackingEvent(eventName, {
    ...Object.fromEntries([...pageWebVitalsAttributes]),
    ...opts,
  });

  pageWebVitals.clear();
};

export const trackPerformance = (pageWebVitals: Map<IWebVitals, number>) => {
  if (
    pageWebVitals.has('FCP') &&
    pageWebVitals.has('TTFB') &&
    pageWebVitals.has('Next.js-hydration') &&
    pageWebVitals.get('DOMComplete') > 0 &&
    pageWebVitals.has('DOMContentLoaded') &&
    pageWebVitals.has('DOMInteractive')
  ) {
    sendPerformanceAnalytics(pageWebVitals, 'INITIAL_PAGE_RENDERING_PERFORMANCE_LOAD');
  } else if (pageWebVitals.has('LCP') && pageWebVitals.has('FID')) {
    sendPerformanceAnalytics(pageWebVitals, 'INTERACTION_PERFORMANCE_LOAD');
  } else if (pageWebVitals.has('CLS') && pageWebVitals.has('INP')) {
    sendPerformanceAnalytics(pageWebVitals, 'INTERACTION_PERFORMANCE_LOAD');
  } else if (
    pageWebVitals.has('Next.js-render') &&
    pageWebVitals.has('Next.js-route-change-to-render')
  ) {
    // The previous path is not set in session storage yet when this call is made, so using currentPath instead, which is the true previous path
    const prevPath = window.sessionStorage.getItem('currentPath');
    sendPerformanceAnalytics(pageWebVitals, 'ROUTE_RENDER_PAGE_PERFORMANCE_LOAD', {
      previous_location: prevPath,
    });
  }
};
